/* eslint-disable import/prefer-default-export */
export const FormInitState = {
  step1: '',
  step2: '',
  step3: '',
};
